import { getEndCursor } from 'components/Blocks/Pagination/paginationHelpers';
import { DEFAULT_PAGE_SIZE } from 'config/constants';
import {
    LoyaltyClubHistoryConnectionFragmentApi,
    LoyaltyClubPointsFragmentApi,
    useLoyaltyClubHistoryQueryApi,
    useLoyaltyClubPointsQueryApi,
} from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { LoyaltyClubHistoryItemType, LoyaltyClubHistoryType, LoyaltyClubPointsType } from 'types/loyaltyClub';

export const useLoyaltyPointsHistory = (page: number): LoyaltyClubHistoryType => {
    const [{ data, error }] = useLoyaltyClubHistoryQueryApi({
        variables: {
            after: getEndCursor(page, 0, DEFAULT_PAGE_SIZE),
            first: DEFAULT_PAGE_SIZE,
        },
    });

    useQueryError(error);

    return {
        totalCount: data?.loyaltyClubHistoryItems.totalCount ?? 0,
        history: mapLoyaltyClubHistory(data?.loyaltyClubHistoryItems),
    };
};

export const useLoyaltyClubPoints = (): LoyaltyClubPointsType | null => {
    const [result] = useLoyaltyClubPointsQueryApi();

    if (result.data === undefined || result.data.loyaltyClubPoints === null) {
        return null;
    }

    return mapLoyaltyClubCustomerUserApiData(result.data.loyaltyClubPoints);
};

const mapLoyaltyClubHistory = (
    data: LoyaltyClubHistoryConnectionFragmentApi | undefined,
): LoyaltyClubHistoryItemType[] => {
    const mappedItems = [];

    if (data?.edges !== undefined && data.edges !== null) {
        for (const itemEdge of data.edges) {
            if (itemEdge?.node !== undefined && itemEdge.node !== null) {
                mappedItems.push({
                    ...itemEdge.node,
                    createdDate: new Date(itemEdge.node.createdDate),
                });
            }
        }
    }

    return mappedItems;
};

const mapLoyaltyClubCustomerUserApiData = (apiData: LoyaltyClubPointsFragmentApi): LoyaltyClubPointsType | null => {
    if (!apiData.enabled) {
        return null;
    }

    return {
        loyaltyClubPoints: apiData.loyaltyClubPoints === null ? 0 : apiData.loyaltyClubPoints,
        loyaltyClubPointsPrice:
            apiData.loyaltyClubPointsPrice === null ? 0 : Number.parseFloat(apiData.loyaltyClubPointsPrice),
        loyaltyClubPointsToExpire: apiData.loyaltyClubPointsToExpire,
        voucherUseAllowed: apiData.voucherUseAllowed,
        addDigitalCardToWalletAllowed: apiData.addDigitalCardToWalletAllowed,
    };
};
